/* global ADV */
import React from 'react';
import PropTypes from 'prop-types';
import { Title, TableContainer, LinkButton, LoadingPlaceholder } from './styles';
import Table from '../../../OrionOnboarding/Steps/OrionAssetClassMapping/Components/TableView';

class AssetClassesView extends React.Component {
  componentDidMount() {
    const { fetchAssetClasses } = this.props;
    fetchAssetClasses();
  }

  componentWillUnmount() {
    const { resetState } = this.props;
    resetState();
  }

  render() {
    const { assetClassesOptions, assetClassMappings, hasLoaded, saveAssetClasses } = this.props;

    return (
      <div>
        <Title>
          For more Orion Planning asset class information please see{' '}
          <LinkButton onClick={() => ADV.util.Router.go2('Assumptions')}>click here.</LinkButton>
        </Title>
        <TableContainer hasLoaded={hasLoaded}>
          <Table
            assetClassMappings={assetClassMappings}
            handleAssetClassMappingChange={(id, newCurrentAssetClass) => {
              const { ExternalAssetClassName } = assetClassMappings[id];
              const { value: AssetClass } = newCurrentAssetClass;

              saveAssetClasses(
                {
                  ExternalAssetClassName,
                  AssetClass,
                },
                id,
              );
            }}
            assetClasses={assetClassesOptions}
          />
        </TableContainer>
      </div>
    );
  }
}

AssetClassesView.propTypes = {
  assetClassesOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  assetClassMappings: PropTypes.arrayOf(
    PropTypes.shape({
      ExternalAssetClassName: PropTypes.string,
    }),
  ).isRequired,
  fetchAssetClasses: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  saveAssetClasses: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired,
};

export default AssetClassesView;
